export default __webpack_public_path__ + "images/ccfc9b4ec7003c9b67524df737a6201b-medical_small.webp";